import { atomWithRefresh } from "../utils";
import { AssetLimitsResponse } from "../types";
import {
  numberOfUniqueChatbotNodesAtom,
  numberOfUniqueInterfaceNodesAtom,
} from "../nodes";
import { zslAtom } from "../templates";

/**
 * Unified atom that fetches asset limits using the new assets/limits API.
 * Only makes API call if there are interface or chatbot nodes to check, as only these are checked for limits.
 */
export const assetLimitsAtom_SUSPENDS = atomWithRefresh<
  Promise<AssetLimitsResponse | null>
>(async (get) => {
  try {
    const numberOfInterfaceNodes = get(numberOfUniqueInterfaceNodesAtom);
    const numberOfChatbotNodes = get(numberOfUniqueChatbotNodesAtom);

    if (numberOfInterfaceNodes === 0 && numberOfChatbotNodes === 0) {
      return { results: {} };
    }

    const template = get(zslAtom);

    if (!template) {
      return { results: {} };
    }

    const response = await fetch("/api/canvasui/assets/limits", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ template }),
    });

    if (!response.ok) {
      console.error(
        "Failed to fetch asset limits for zsl:",
        response.status,
        response.statusText,
      );
      return null;
    }

    const json: AssetLimitsResponse = await response.json();
    return json;
  } catch (error) {
    console.error("Error fetching asset limits:", error);
    return null;
  }
});

assetLimitsAtom_SUSPENDS.debugLabel = "assetLimitsAtom_SUSPENDS";
